"use client";

import { useState, memo, type ChangeEvent, useEffect } from "react";
import {
	HmcIcon,
	HmcInputField,
} from "@adi-ctx/harmonic-core-components-react";
import { withHydrationFixed } from "@/components";

type TProps = {
	readonly isDisabled?: boolean;
	readonly value?: string;
	readonly width?: string;
	readonly placeholder: string;
	readonly onChange?: (keyword: string) => void;
	readonly onKeyDown?: (
		e: KeyboardEvent & ChangeEvent<HTMLInputElement>
	) => void;
};

/**
 * Displays a keyword search input for filtering
 * @constructor
 */

function FilterKeywordSearch({
	placeholder,
	width = "100%",
	value = "",
	isDisabled = false,
	onChange,
	onKeyDown,
}: TProps) {
	const InputFieldWithHydrationFixed = withHydrationFixed(HmcInputField);
	const [keyword, setKeyword] = useState(value);

	const handleOnChange = ({
		detail: { value: keyword },
	}: {
		detail: { value: string };
	}) => {
		setKeyword(keyword);

		if (typeof onChange === "function") {
			onChange(keyword);
		}
	};

	return (
		<InputFieldWithHydrationFixed
			isClearable
			disabled={isDisabled}
			placeholder={placeholder}
			data-testid="filter-keyword-search"
			inputMode="search"
			enterkeyhint="enter"
			className="block bg-layoutContainer"
			width={width}
			value={keyword}
			onHmcChange={handleOnChange}
			onKeyDown={onKeyDown}
		>
			<HmcIcon
				name="search-m"
				slot="prefix"
				color="var(--hmc-color-system-info-default)"
			/>
		</InputFieldWithHydrationFixed>
	);
}

export default memo(FilterKeywordSearch);
